var $2569ca3917233115$exports = {};
$2569ca3917233115$exports = {
  "breadcrumbs": "Morzsamen\xFC"
};
export { $2569ca3917233115$exports as default };